import { type DietaryRestrictionsText } from '@hungryroot/dietary-restrictions';
import { type IngredientDetails } from '../../../hooks/useIngredientDetails';

export const getEffectiveDietaryIngredients = (
  ingredientDetails: IngredientDetails,
  netIngredients: number[]
) => {
  return Array.from(
    new Set(
      Object.values(ingredientDetails)
        .filter((ingredient) => {
          return netIngredients.includes(ingredient.id);
        })
        .reduce((acc, ingredient) => {
          if (ingredient.dietaryIngredients) {
            return [...acc, ...ingredient.dietaryIngredients];
          }
          return acc;
        }, [] as DietaryRestrictionsText[])
    )
  );
};
